import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_e76pvrt6ut: FaireCollectionEntity = {
  token: "pbc_e76pvrt6ut",
  type: "collection",
  name: "On the Line: Seam Detail Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/af22c97a48a3969423902e986dd159658de5b2cc40ddfdd3271a867ae41f2bd4.jpeg",
  itemCount: 21,
  description:
    "Elevate your denim lineup with our On the Line: Seam Detail Collection. Thoughtful stitching, flattering lines, and unique seamed designs bring a fresh, sculpted look to classic Judy Blue comfort. It’s all in the details—style that speaks for itself.",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:15.633Z",
    importedBy: "entity-db-import-collections",
  },
};
